import {StpAccount} from "@/models/StpAccount";
import {Profile} from "@/models/LoanPayment/Profile";
import {LoanTransaction} from "@/models/LoanPayment/LoanTransaction";
import {LoanProject} from "@/models/LoanPayment/Project";
import {LoanBankAccount} from "@/models/LoanPayment/LoanBankAccount";
import {LoanPayment} from "@/models/LoanPayment/LoanPayment";
import {BankAccountStatus} from "@/models/BankAccountStatus";

export class ProjectTransform {
    static fromRequest(data) {
        let stpAccount = null;
        if (data.profile.stp_account !== null) {
            stpAccount = new StpAccount(
                data.profile.stp_account.id,
                data.profile.stp_account.stp_clabe,
                data.profile.stp_account.status
            )
        }

        let bankAccountDefault = null;
        if (data.profile.bank_account !== null) {
            bankAccountDefault = new LoanBankAccount(
                data.profile.bank_account.id,
                data.profile.bank_account.bank,
                data.profile.bank_account.clabe,
                data.profile.bank_account.stp_code,
                data.profile.bank_account.verified,
                data.profile.bank_account.verified_date
            );
        }

        let bankAccounts = data.profile.bank_accounts.map(bankAccount => {
            return new LoanBankAccount(
                bankAccount.id,
                bankAccount.bank,
                bankAccount.clabe,
                bankAccount.stp_code,
                bankAccount.verified,
                bankAccount.verified_date
            );
        });

        /**
         * @type {Profile}
         */
        let profile = new Profile(
            data.profile.id,
            data.profile.name,
            data.profile.prefix,
            stpAccount,
            bankAccountDefault,
            bankAccounts
        );

        if (data.profile.bank_account !== null) {
            let isVerified = data.profile.bank_account.verified === BankAccountStatus.VERIFIED;

            profile.addItem("Banco", data.profile.bank_account.bank, null)
            profile.addItem("Cuenta", data.profile.bank_account.clabe, isVerified)
        } else {
            profile.addItem("Banco", "Sin cuenta bancaría", null)
            profile.addItem("Cuenta", "Sin clabe interbancaría", false)
        }

        this.fillPayments(profile, data.payments)

        for (let transaction of data.transactions) {
            profile.addTransaction(
                new LoanTransaction(
                    transaction.id,
                    transaction.profile_id,
                    transaction.trx_type,
                    transaction.amount,
                    transaction.concept,
                    transaction.status,
                    transaction.created_at,
                    transaction.trx_confirmation_date
                )
            );
        }

        let project = new LoanProject(
            data.id,
            data.loan_type,
            data.total_cost,
            profile,
            data.financed_amount,
            data.insurance,
            data.monthly_payment,
            data.admin_commission,
            data.financed_interest,
            data.complete_evidence_date,
            data.fund_date,
            data.installation_date,
            data.supplier_funding_fee_percentage,
            data.deposit,
            data.opening_commission,
            data.applicant_fee_1,
            data.applicant_fee_2,
            data.credit_disposal_amount,
        );

        for (let clientInvoice of data.client_invoices) {
            project.addClientInvoice(
                clientInvoice.id,
                clientInvoice.trx_type,
                clientInvoice.profile_id,
                clientInvoice.profile_name,
                clientInvoice.concept,
                clientInvoice.amount,
                clientInvoice.pdf_file,
                clientInvoice.xml_file,
                clientInvoice.trx_confirmation_date,
            );
        }

        for (let supplierInvoice of data.supplier_invoices) {
            project.addSupplierInvoice(
                supplierInvoice.id,
                supplierInvoice.trx_type,
                supplierInvoice.profile_id,
                supplierInvoice.profile_name,
                supplierInvoice.concept,
                supplierInvoice.amount,
                supplierInvoice.pdf_file,
                supplierInvoice.xml_file,
                supplierInvoice.trx_confirmation_date,
            );
        }

        for (let penalty of data.penalties) {
            project.addPenalty(
                penalty.id,
                penalty.profile_id,
                penalty.trx_type,
                penalty.amount,
                penalty.concept,
                penalty.status,
                penalty.created_at,
                penalty.trx_confirmation_date,
            );
        }

        for (let bonus of data.bonus) {
            project.addBonus(
                bonus.id,
                bonus.profile_id,
                bonus.trx_type,
                bonus.amount,
                bonus.concept,
                bonus.status,
                bonus.created_at,
                bonus.trx_confirmation_date,
            );
        }

        for (let contract of data.contracts) {
            project.addContract(contract);
        }

        return project;
    }

    static fillPayments(profile, payments) {
        for (let payment of payments) {
            profile.addPayment(
                new LoanPayment(
                    payment.id,
                    profile.id,
                    profile.name,
                    payment.project_id,
                    payment.order,
                    payment.amount,
                    payment.status,
                    payment.payment_request_date,
                    payment.payment_percentage,
                    payment.has_fee,
                    payment.fee_percentage
                )
            );
        }
        return profile;
    }
}